import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/company/$")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: "/recruit/" + params._splat })
  },
  component: () => null,
})
